import { render, staticRenderFns } from "./aLteSmallBox.vue?vue&type=template&id=6e18140c"
import script from "./aLteSmallBox.vue?vue&type=script&lang=js"
export * from "./aLteSmallBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dem/Go/src/github.com/demget/quadroclub/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6e18140c', component.options)
    } else {
      api.reload('6e18140c', component.options)
    }
    module.hot.accept("./aLteSmallBox.vue?vue&type=template&id=6e18140c", function () {
      api.rerender('6e18140c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/small-box/aLteSmallBox.vue"
export default component.exports